export const schemeListTranslations = {
    en: {
        // Page Title & Headers
        schemesList: "Schemes List",

        // Table Headers
        actions: "Actions",
        schemeName: "Scheme Name",
        description: "Description",
        diseases: "Diseases",
        registeredOn: "Registered On",

        // Buttons
        addScheme: "Add Scheme",

        // Dialog Titles
        createNewScheme: "Create New Scheme",
        updateSchemeDetails: "Update Scheme Details",
        schemeDetailsTitle: ' Details',
        deleteSchemeTitle: 'Delete  Details',

        // Common
        notAvailable: "N/A"
    },
    mr: {
        // Page Title & Headers
        schemesList: "योजनांची यादी",

        // Table Headers
        actions: "क्रिया",
        schemeName: "योजनेचे नाव",
        description: "वर्णन",
        diseases: "रोग",
        registeredOn: "नोंदणी तारीख",

        // Buttons
        addScheme: "योजना जोडा",

        // Dialog Titles
        createNewScheme: "नवीन योजना तयार करा",
        updateSchemeDetails: "योजना तपशील अपडेट करा",
        schemeDetailsTitle: ' तपशील',
        deleteSchemeTitle: ' तपशील हटवा',

        // Common
        notAvailable: "उपलब्ध नाही"
    }
};
